import { Trans } from "@lingui/macro";
import { UiBox, UiButton, UiLink, UiTypography } from "@smp/ui";

import { HelperAdapterLink } from "@/components/helpers/helper_adapter_link";

import { useStyles } from "./block_try_pro.css";

export const BlockTryPro = ({
  additionalAction,
  background = false,
}: {
  additionalAction?: () => void;
  background?: boolean;
}) => {
  const handleClick = () => {
    additionalAction && additionalAction();
  };

  const classes = useStyles();

  return background ? (
    <UiBox className={classes.card_promo}>
      <UiTypography variant="h4" gutterBottom gutterBottomSize="lg">
        <Trans>Breathe freely, upgrade to a PRO Plan!</Trans>
      </UiTypography>
      <UiButton
        color="paper"
        component={HelperAdapterLink}
        onClick={handleClick}
        to="/billing/plans"
        variant="contained"
      >
        <Trans>Try PRO plan for free</Trans>
      </UiButton>
    </UiBox>
  ) : (
    <UiTypography>
      <Trans>Still counting posts? Find something more important to do!</Trans>{" "}
      <UiLink
        component={HelperAdapterLink}
        onClick={handleClick}
        to="/billing/plans"
      >
        <Trans>Try Pro!</Trans>
      </UiLink>
    </UiTypography>
  );
};
